import { useEffect, useRef } from "react";

const useEffectOnce = (callback, deps = []) => {
    const effectRun = useRef(false);
    useEffect(() => {
        if (effectRun.current === true || process.env.NODE_ENV !== "development") {
            callback();
        }

        return () => (effectRun.current = true);
    }, deps);
};

export default useEffectOnce;
